import EditProjectModalContainer from './containers/EditProjectModalContainer'

export default EditProjectModalContainer
